import {
  createBrowserRouter,
  LoaderFunctionArgs,
  Navigate,
  redirect,
} from "react-router-dom";
import {
  Home,
  Login,
  ReadDocuments,
  DetailedConsultation,
  ViewFiles,
  Maintenance,
  AutorizationPayments,
  PaymentProcessSummary,
  ExportedInvoicePackages,
  ViewExportedPackage,
  SubmitiInvoice,
  UploadPaymentSupports,
  Deductions,
  CostCenter,
} from "pages";
import { LoginSuccess } from "shared/auth/LoginSuccess";
import { loginType } from "shared/utils/helpers/loginType";
import { Root } from "../shared/auth/Root";
import { RouterGuard } from "shared/components/RouteGuard";
import { accesRoles } from "../shared/models/roles";
import { ValidateLogin } from "../shared/auth/ValidateLogin";
import { ReportsView } from "pages/reports-view/ReportsView";
import { ReportPreview } from "pages/report-preview-single/ReportPreview";
import { getQueryParam } from "../shared/auth/oauh2-with-pkce/util";
import { ConsolidateGlosas } from "pages/consolidate-glosas/ConsolidateGlosas";
import { SeeContractDetails } from "pages/detailed-consultation/components/SeeContractDetails.tsx";
import { ExternalUser } from "pages/user-external/ExternalUser";
import { Contracts } from "pages/contracts-pages/Contracts";
import { UserManagement } from "pages/user-provider-management/UserManagement";
import { RecoveryFeePdfView } from "pages/view-pdf-recovery-fee/RecoveryFeePdfView";
import { UsersTfe } from "pages/user-management/UsersTfe";

export const routerConfig = createBrowserRouter([
  {
    path: "/",
    loader: () => {
      if (!!!getQueryParam("LT") && !!!loginType()) throw redirect("/login");
      return getQueryParam("LT") || loginType();
    },
    element: <Root />,
    children: [
      {
        index: true,
        element: (
          <RouterGuard roles={accesRoles.reader} type="route">
            <Home />
          </RouterGuard>
        ),
      },
      {
        path: "/consulta_documentos_electronicos",
        element: (
          <RouterGuard roles={accesRoles.reader} type="route">
            <ReadDocuments />
          </RouterGuard>
        ),
      },
      {
        path: "/consulta_documentos_electronicos/detalle_documento/:idDocument",
        element: (
          <RouterGuard roles={accesRoles.reader} type="route">
            <DetailedConsultation />
          </RouterGuard>
        ),
      },
      {
        path: "/consulta_documentos_electronicos/detalle_documento/:idDocument/auditar_glosas",
        element: (
          <RouterGuard roles={accesRoles.auditor} type="route">
            <ConsolidateGlosas />
          </RouterGuard>
        ),
      },
      {
        path: "/consulta_documentos_electronicos/detalle_documento/:idDocument/ver_detalle_contrato/:idContract",
        element: (
          <RouterGuard roles={accesRoles.auditor} type="route">
            <SeeContractDetails />
          </RouterGuard>
        ),
      },
      {
        path: "/consulta_documentos_electronicos/detalle_documento/:idDocument/:file/:id",
        element: (
          <RouterGuard roles={accesRoles.reader} type="route">
            <ViewFiles />
          </RouterGuard>
        ),
      },
      {
        path: "/consulta_documentos_electronicos/radicar_facturas/:id",
        element: (
          <RouterGuard roles={accesRoles.healthProvider} type="route">
            <SubmitiInvoice />
          </RouterGuard>
        ),
      },
      {
        path: "/consulta_documentos_electronicos/cargar_soportes_pagos",
        element: (
          <RouterGuard roles={accesRoles.adminUser} type="route">
            <UploadPaymentSupports />
          </RouterGuard>
        ),
      },
      {
        path: "/reportes",
        element: (
          <RouterGuard roles={accesRoles.reader} type="route">
            <ReportsView />
          </RouterGuard>
        ),
      },
      {
        path: "/reportes/:idReport",
        element: (
          <RouterGuard roles={accesRoles.reader} type="route">
            <ReportPreview />
          </RouterGuard>
        ),
      },
      {
        path: "/autorizaciones",
        element: (
          <RouterGuard roles={accesRoles.financialModule} type="route">
            <AutorizationPayments />
          </RouterGuard>
        ),
      },
      {
        path: "/autorizaciones/paquetes-exportados",
        element: (
          <RouterGuard roles={accesRoles.financialModule} type="route">
            <ExportedInvoicePackages />
          </RouterGuard>
        ),
      },
      {
        path: "/autorizaciones/paquetes-exportados/:packageId",
        element: (
          <RouterGuard
            roles={accesRoles.financialModuleWithHealthProvider}
            type="route"
          >
            <ViewExportedPackage />
          </RouterGuard>
        ),
      },
      {
        path: "/autorizaciones/resumen-proceso-pago",
        element: (
          <RouterGuard
            roles={[
              ...accesRoles.financialModule,
              ...accesRoles.processAdministrator,
            ]}
            type="route"
          >
            <PaymentProcessSummary />
          </RouterGuard>
        ),
      },
      {
        path: "/autorizaciones/gestion-deducciones",
        element: (
          <RouterGuard roles={accesRoles.financialModule} type="route">
            <Deductions />
          </RouterGuard>
        ),
      },
      {
        path: "/autorizaciones/administrar-centro-costo",
        element: (
          <RouterGuard roles={accesRoles.financialModule} type="route">
            <CostCenter />
          </RouterGuard>
        ),
      },
      {
        path: "/autorizaciones/detalle_documento/:idDocument",
        element: (
          <RouterGuard roles={accesRoles.financialModule} type="route">
            <DetailedConsultation />
          </RouterGuard>
        ),
      },
      {
        path: "/couta-recuperacion/pdf/:id",
        element: (
          <RouterGuard roles={accesRoles.usersSSSA} type="route">
            <RecoveryFeePdfView />
          </RouterGuard>
        ),
      },
      {
        path: "/documento/pdf/:id",
        element: (
          <RouterGuard roles={accesRoles.reader} type="route">
            <RecoveryFeePdfView />
          </RouterGuard>
        ),
      },
      {
        path: "/contratos",
        element: (
          <RouterGuard roles={accesRoles.usersSSSA} type="route">
            <Contracts />
          </RouterGuard>
        ),
      },
      {
        path: "/gestion-usuarios-prestadores",
        element: (
          <RouterGuard roles={accesRoles.adminUser} type="route">
            <UserManagement />
          </RouterGuard>
        ),
      },
      {
        path: "/gestion-usuarios",
        element: (
          <RouterGuard roles={accesRoles.adminUser} type="route">
            <UsersTfe />
          </RouterGuard>
        ),
      },
      {
        path: "/usuario_externo",
        element: <ExternalUser />,
      },
      {
        path: "/mantenimiento",
        element: <Maintenance />,
      },
      {
        path: "/*",
        element: <Navigate to="/" />,
      },
    ],
  },
  {
    path: "/login",
    element: (
      <ValidateLogin>
        <Login />
      </ValidateLogin>
    ),
  },
  {
    path: "/login/callback",
    element: <LoginSuccess />,
    loader: ({ params }: LoaderFunctionArgs) => {
      if (!!params.code || !!!loginType()) {
        throw redirect("/login");
      }
      return loginType();
    },
  },
]);
